import { mergeStyles } from '@cian/utils';
import * as React from 'react';

import styles from './Controls.css';
import { trackPhotoTabClick, trackVideoTabClick } from '../../../tracking';
import { MenuButton } from '../MenuButton';

export interface IControlsProps {
  photoCount: number;
  videoCount: number;
  photoFirstIndex: number;
  videoFirstIndex: number;
  isVideoPlaying: boolean;
  isInitialized: boolean;

  onElementShow(id: number): void;
}

export const Controls = (props: IControlsProps) => {
  const { isInitialized, isVideoPlaying, onElementShow, photoCount, videoCount, photoFirstIndex, videoFirstIndex } =
    props;
  const isSingle = photoCount + videoCount <= 1;

  if (!isInitialized) {
    return (
      <noscript>
        <h2>{photoCount} фото</h2>
      </noscript>
    );
  }

  return (
    <div
      {...mergeStyles(styles['controls'], isVideoPlaying && styles['controls--hidden'], isSingle && styles['single'])}
    >
      {!!videoCount && (
        <MenuButton
          type="video"
          elementsCount={1}
          id={videoFirstIndex}
          onButtonClick={(id: number) => {
            trackVideoTabClick();
            onElementShow(id);
          }}
        />
      )}
      {!!photoCount && (
        <MenuButton
          type="photo"
          elementsCount={photoCount}
          id={photoFirstIndex}
          onButtonClick={(id: number) => {
            trackPhotoTabClick();
            onElementShow(id);
          }}
        />
      )}
    </div>
  );
};
